import { SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';

import { AppState } from '../../bootstrap/redux/state/AppState';
import {
  isNavLocationInAreas,
  NavLocation,
  NavLocationAreas
} from '../components/layout/NavLocation';

export namespace NavLocationSelectors {
  export function selectNavLocation(state: AppState): NavLocation {
    return state.navigationState.navLocation;
  }

  export function inServerArea(state: AppState): boolean {
    const location = selectNavLocation(state);
    return isNavLocationInAreas(location, NavLocationAreas.ServerAdmin);
  }

  export function inSiteArea(state: AppState): boolean {
    const location = selectNavLocation(state);
    const inArea = isNavLocationInAreas(location, NavLocationAreas.SiteContent, NavLocationAreas.SiteAdmin);
    return inArea || SessionUserSelectors.isSingleSiteServerAdmin(state);
  }

  export function inSiteContentArea(state: AppState) {
    const location = selectNavLocation(state);
    return isNavLocationInAreas(location, NavLocationAreas.SiteContent);
  }

  export function inVizViewerArea(state: AppState) {
    const location = selectNavLocation(state);
    return (location === NavLocationAreas.SiteContent.site_viz ||
            location === NavLocationAreas.SiteAdmin.site_viz ||
            location === NavLocationAreas.ServerAdmin.server_viz ||
            location === NavLocationAreas.SiteContent.usage_analytics ||
            location === NavLocationAreas.SiteContent.metric_detail ||
            (state.spaceInfo.spaceType === 'predictiveModel' && !state.spaceInfo.subspaceName));
  }

  export function inSiteStatusViz(state: AppState) {
    const location = selectNavLocation(state);
    return location === NavLocationAreas.SiteAdmin.site_viz;
  }

  export function inServerStatusViz(state: AppState) {
    const location = selectNavLocation(state);
    return location === NavLocationAreas.ServerAdmin.server_viz;
  }

  export function inSearchNavLocation(state: AppState) {
    return selectNavLocation(state) === NavLocationAreas.SiteContent.search;
  }

  export function isMetricDetail(state: AppState) {
    const location = selectNavLocation(state);
    return location === NavLocationAreas.SiteContent.metric_detail;
  }

  export function inSettingsLocation(state: AppState) {
    const location = selectNavLocation(state);
    return location === NavLocationAreas.ServerAdmin.server_settings ||
      location === NavLocationAreas.SiteAdmin.site_settings;
  }
}

export function selectPreviousUrl(state: AppState): string {
  return state.navigationState.previousUrl;
}
